import React from "react";
import { Box, Text, Tip } from "grommet";
import styled from "styled-components";
import {
    faEnvelope as IconEnvelope,
    faArrowUpRightFromSquare as IconExpand
} from '@fortawesome/pro-light-svg-icons';
import FontAwesomeIcon from "../../FontAwesomeIcon";
import { DisplayInlineBlockBox, UnderlinedText } from "../../../utils/styled";
import {isObjectEmpty} from "../../../utils/object";
import CopyLinkWidget from "../../CopyLinkWidget";
import { snakeCase } from "../../../utils/string";
import Button from "../../Button";
import { DROPDOWN_MENU_DESKTOP_WIDTH } from "../../../constants/Dimensions";

const BorderlessButton = styled(Button)`
    border: none;
`;

const CopyPasteButton = styled(Button)`
    border: none;
    border-radius: 0;
`;
const NewInvoiceMenu = ({
    shopifySyncData,
    onImportFromFileClicked,
    additionalMenuItems=[],
    wrapperProps
}) => {
    const copyLink = () => {
        if (typeof window !== "undefined") {
            const tempText = document.createElement('textarea');
            tempText.value = 'invoice@streamlined.app';
            document.body.appendChild(tempText);
            tempText.select();
            document.execCommand('copy');
            document.body.removeChild(tempText);
        }
    };
    const orderEmail = (process.env.NODE_ENV === 'production') ? (process.env.NEXT_PUBLIC_VERCEL_ENV === 'preview' ? "invoice@streamlined.dev" : "invoice@streamlined.app") : "invoice@streamlined.dev"

    return (
        <Box align='start' width={DROPDOWN_MENU_DESKTOP_WIDTH} border pad='xsmall' gap="small" {...wrapperProps}>
            <Box fill="horizontal">
                {(
                    !isObjectEmpty(shopifySyncData) && (
                        shopifySyncData.map((connection, index) => (
                            <BorderlessButton
                                event={{section: 'draft_invoice_list_page_header', element: 'create_shopify_order'}}
                                key={index}
                                fill
                                onClick={()=>{window.open(
                                    `https://${connection.shop_domain}.myshopify.com/admin/draft_orders/new`,
                                    "_blank"
                                );}}
                                pad={{horizontal: 'small', vertical: 'xsmall'}}
                                label={(
                                    <Box align='center' direction="row" gap="xsmall" justify="start">
                                        <Text weight={400}>Create on {connection.name}</Text>
                                        <FontAwesomeIcon SelectedIcon={IconExpand} size="xxsmall" color="text-weak" />
                                    </Box>
                                )}
                            />)
                        )
                    )
                )}
                <BorderlessButton
                    event={{section: 'draft_invoice_list_page_header', element: 'import_from_pdf'}}
                    fill
                    pad={{horizontal: 'small', vertical: 'xsmall'}}
                    onClick={onImportFromFileClicked}
                    label={(
                        <Box align='start'>
                            <Text weight={400}>Import from file</Text>
                        </Box>
                    )}
                />
                {additionalMenuItems && additionalMenuItems.map((itemProps, id)=>{
                    return(
                        <BorderlessButton
                            event={{section: 'draft_invoice_list_page_header', element: snakeCase(itemProps.label)}}
                            fill
                            key={id}
                            pad={{horizontal: 'small', vertical: 'xsmall'}}
                            onClick={itemProps.onClick}
                            label={(<Box align='start'><Text weight={400}>{itemProps.label}</Text></Box>)}
                        />
                    )
                })}
            </Box>
            <Box border='top' fill="horizontal" pad="small" gap='xsmall'>
                <Box margin={{top: 'xsmall'}}>
                    <Text>Forward sales order via email</Text>
                </Box>
                <CopyLinkWidget link={orderEmail} icon={IconEnvelope}/>
                <DisplayInlineBlockBox>
                    <Tip
                        content={(
                            <Box width={{max: 'medium'}} pad="xsmall" gap="xsmall">
                                <Text>
                                    If you have an email that contains order details, try forwarding it to us!
                                </Text>
                                <Text>
                                    Streamlined automatically picks up relevant information from your email's attachment, and creates a draft invoice for you.
                                </Text>
                            </Box>
                        )}>
                        <UnderlinedText
                            textDecoration="underline" 
                            color='text-weak'
                            size="small">
                                How does it work?
                        </UnderlinedText>
                    </Tip>
                </DisplayInlineBlockBox>
            </Box>
        </Box>)
};

export default NewInvoiceMenu;
